import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { rememberFieldRules, rememberReservedFieldTypeIds } from 'src/app/shared/formula/formula.types';


@Injectable({
  providedIn: 'root'
})
export class ItemsService {
  BASE_URL: string;
  ITEM_MODULE_URL: string;
  LEAD_MANAGEMENT:string;
  constructor(private http: HttpClient) {
    this.BASE_URL = environment.API_URL;
    this.ITEM_MODULE_URL = environment.ITEM_MODULE_URL;
    this.LEAD_MANAGEMENT =environment.LEAD_MANAGEMENT_URL;
  }


  categoryAdd(resource) {
    return this.http.post(this.BASE_URL + '/category', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updateAddress(resource) {
    return this.http.put(this.BASE_URL + '/formcontacts', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  categoryUpdate(resource) {
    return this.http.post(this.ITEM_MODULE_URL + '/category/categoryUpdate', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  customerCustomFieldList(data: any = ''): Observable<any> {
    return this.http.post(this.ITEM_MODULE_URL + '/customFieldList', data).pipe(
      // Card #566: the Formula / Number type ids ride on this response.
      tap((response: unknown) => rememberReservedFieldTypeIds(response)),
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  updateCustomeOrder(data: any = ''): Observable<any> {
    return this.http.put(this.ITEM_MODULE_URL + '/updateitemsCustomOrder', { data })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  createCategorySearchHistory(resource) {
    return this.http.post(this.ITEM_MODULE_URL + '/category/create/search', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  itemSearchQuote(resource = '') {
    return this.http.post(this.ITEM_MODULE_URL + '/item/fast-list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }



  itemSearch(resource = '') {
    return this.http.post(this.ITEM_MODULE_URL + '/item/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  

  eQuoteItemSearch(resource:any = '') {
    return this.http.post(this.ITEM_MODULE_URL + '/item/eQuote/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  itemSearchUploaded(resource = '') {
    return this.http.post(this.ITEM_MODULE_URL + '/uploaded/', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  getItemsBySubcategory( resource): Observable<any> {
    return this.http.post<any>(this.ITEM_MODULE_URL  + '/item/itemsBySubcategory', resource)
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
}
updateItemBulkPrice(resource) {
  return this.http.put(this.ITEM_MODULE_URL + '/item/bulkprice', resource)
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
}
  // getItems(resource = ''): Observable<any> {
  //   return this.http.post(this.BASE_URL + '/item/list', resource).pipe(
  //     // tap(
  //     //   data => data,
  //     //   error => error
  //     // ),
  //     map((response: any) => {
  //       return response;
  //     }),
  //     catchError((err: any) => {
  //       return null;
  //     })
  //   );
  // }


  currenciesList(resource: any = '') {
    return this.http.post(this.BASE_URL + '/currency/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }


  cateogryList(resource:any = '') {
    return this.http.post(this.BASE_URL + '/category/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  eQuoteCateogryList(resource:any = '') {
    return this.http.post(this.ITEM_MODULE_URL + '/category/eQuoteCategory', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }
  updateComments(resource:any = '') {
    return this.http.post(this.ITEM_MODULE_URL + '/item/updateComments', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }
  getSearchList() {
    return this.http.get(this.ITEM_MODULE_URL + '/category/getSearchHistory')
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  deleteItem(id) {
    return this.http.delete(this.BASE_URL + '/item/' + id)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  deleteBulkItem(id) {
    return this.http.post(this.ITEM_MODULE_URL + '/item/bulkdelete' , id)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }
  cloneBulkItem(data) {
    return this.http.post(this.BASE_URL + '/item/bulkclone' , data)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }
  addCloneItem(resource): Observable<any>{
    return this.http.post(this.ITEM_MODULE_URL + '/item/cloneitems', resource)
    .pipe(
      tap(
        data => data,
        error => error
      )
    );
  }




  subCateogryList(resource = '') {
    return this.http.post(this.BASE_URL + '/subcategory/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updateItem(resource) {
    return this.http.put(this.ITEM_MODULE_URL + '/item', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updateItemPrice(resource) {
    return this.http.put(this.ITEM_MODULE_URL + '/item/price', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }
//Download lead csv catalog 
getDownloadcvsCatalog(): Observable<any> {
  return this.http.post(`${this.ITEM_MODULE_URL}/item/download/catalog`, { responseType: 'text' })
}

  bundleList(resource = '') {
    return this.http.post(this.BASE_URL + '/bundle/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  iteamDataList(id, hideLoader = false) {
    const options = hideLoader ? { headers: { 'X-Hide-Loader': 'true' } } : {};
    return this.http.get(this.BASE_URL + '/item/' + id, options)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }



  warehouseList(resource: any = '') {
    return this.http.post(this.BASE_URL + '/warehouse/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  taxList(resource = '') {
    return this.http.post(this.BASE_URL + '/taxes/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  unitList(resource = '') {
    return this.http.post(this.BASE_URL + '/units/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  subCategorySearch(resource = '') {
    return this.http.post(this.BASE_URL + '/subcategory/list', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  addSubCateogry(resource) {
    return this.http.post(this.BASE_URL + '/subcategory', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  updateItemsSubCateogry(resource) {
    return this.http.post(this.ITEM_MODULE_URL + '/subcategory/subcategoryUpdate', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  addNewWarehouse(resource) {
    return this.http.post(this.BASE_URL + '/warehouse', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }


  addNewTex(resource) {
    return this.http.post(this.BASE_URL + '/taxes', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }


  addNewBundle(resource) {
    return this.http.post(this.BASE_URL + '/bundle', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }


  addNewUnit(resource) {
    return this.http.post(this.BASE_URL + '/units', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  addItem(resource): Observable<any>{
    return this.http.post(this.ITEM_MODULE_URL + '/item', resource)
    .pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  updateTexValues(resource): Observable<any>{
    return this.http.post(this.ITEM_MODULE_URL + '/item/texValues', resource)
    .pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  itemTexValues(resource): Observable<any>{
    return this.http.post(this.ITEM_MODULE_URL + '/item/itemTexValues', resource)
    .pipe(
      tap(
        data => data,
        error => error
      )
    );
  }

  itemTexCustomValuess(resource:any=''): Observable<any>{
    return this.http.post(this.ITEM_MODULE_URL + '/item/itemTexCustomValues',resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }
 

  uploadItemPhoto(resource) {
    return this.http.patch(this.BASE_URL + '/item/item_image', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  uploadItemImages(resource) {
    return this.http.patch(this.BASE_URL + '/item', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  uploadItemOrder(resource) {
    return this.http.post(this.ITEM_MODULE_URL + '/item/item_image_order', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  addCustomValue(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/customvalues/add', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  userCustomUrl(data: any = ''): Observable<any> {
    return this.http.post(this.ITEM_MODULE_URL + '/item/customUrl', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  getTaxesList(data: any = ''): Observable<any> {
    return this.http.post(this.BASE_URL + '/customvalues/getCustomValues', data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  removeCustomValue(data: any = ''): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/customvalues/removeCustomValues/` + data.id, data).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }
  removeCategoryValue(data: any = ''): Observable<any> {
    return this.http.delete(`${this.ITEM_MODULE_URL}/category/${data.id}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  removeSubCategoryValue(data: any = ''): Observable<any> {
    return this.http.delete(`${this.BASE_URL}/subcategory/${data.id}`).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }


  createCustomField(data: any = ''): Observable<any> {
    return this.http.post(this.ITEM_MODULE_URL + '/create/custom/field', data, { withCredentials: true })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  getFormulaVariables(data: any = {}): Observable<any> {
    return this.http.post(this.ITEM_MODULE_URL + '/formula-variables', data, { withCredentials: true }).pipe(
      // Card #566: the type ids and the one copy of the name / unit / run-order rules ride here.
      tap((response: unknown) => {
        rememberReservedFieldTypeIds(response);
        rememberFieldRules(response);
      }),
      map((response: any) => response),
      catchError((err: any) => throwError(() => err))
    );
  }

  validateFormula(payload: { formula_json: any; context?: Record<string, number> }): Observable<any> {
    return this.http.post(this.ITEM_MODULE_URL + '/validate-formula', payload, { withCredentials: true }).pipe(
      map((response: any) => response),
      catchError((err: any) => throwError(() => err))
    );
  }


  updateItemCustomfield(id, data: any = ''): Observable<any> {
    return this.http.put(this.ITEM_MODULE_URL + '/updateItemsCustomfield', {...data, id }, { withCredentials: true })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  itemcustomFieldList(data: any = ''): Observable<any> {
    return this.http.post(this.ITEM_MODULE_URL + '/customFieldList', data, { withCredentials: true }).pipe(
      tap((response: unknown) => rememberReservedFieldTypeIds(response)),
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
  }

  deleteCustomField(resource:any): Observable<any> {
    return this.http.post(`${this.ITEM_MODULE_URL}/deleteCustomField`, resource, { withCredentials: true }).pipe(
      tap(data => data, error => error));
  }

  updateIsQuote(resource:any = '') {
    return this.http.post(this.ITEM_MODULE_URL + '/item/updateIsQuote', resource)
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((err: any) => throwError(() => err))
      );
  }

  searchBySubcategory( resource): Observable<any> {
    return this.http.post<any>(this.ITEM_MODULE_URL  + '/item/searchBySubcategory', resource)
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
}

filterItems(resource:any = '') {
  return this.http.get(this.ITEM_MODULE_URL + '/item/filterItems', resource)
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError((err: any) => throwError(() => err))
    );
}

formContactList(data: any = ''): Observable<any> {
  return this.http.post(this.BASE_URL + '/formcontacts/list', data).pipe(
    map((response: any) => {
      return response;
    }),
    catchError((err: any) => throwError(() => err))
  );
}

getTagsList(data: any = ''): Observable<any> {
  return this.http.get(`${this.LEAD_MANAGEMENT}/get/allTag-List-deals`, data).pipe(
    tap(
      data => data,
      error => error
    )
  );
}
}
